export default __webpack_public_path__ + "static/media/slogan.477ccdd7.svg";